import {
  SignInManager,
  type LimitedOfferPrices,
} from '@/scenes/Editor/components/Navbar/components/SignInManager'

/** How long an offer waits for its prices before skipping the moment. */
export const PRICE_WAIT_MS = 3000

/** Starts fetching the offer's prices in the background (once per session). */
export function prefetchLimitedOfferPrices(): void {
  SignInManager.getInstance().getLimitedOfferPrices().catch(() => {})
}

/** The prices if already fetched, so the modal can show them on its first frame. */
export function getReadyLimitedOfferPrices(): LimitedOfferPrices | null {
  return SignInManager.getInstance().peekLimitedOfferPrices()
}

/**
 * Resolves with the prices, or `null` if they aren't ready within `timeoutMs`
 * (`null` waits without a limit) or can't be fetched.
 */
export function waitForLimitedOfferPrices(
  timeoutMs: number | null = PRICE_WAIT_MS,
): Promise<LimitedOfferPrices | null> {
  const ready = getReadyLimitedOfferPrices()
  if (ready) return Promise.resolve(ready)
  return new Promise(resolve => {
    const timer = timeoutMs === null ? undefined : setTimeout(() => resolve(null), timeoutMs)
    SignInManager.getInstance().getLimitedOfferPrices()
      .then(prices => resolve(prices))
      .catch(() => resolve(null))
      .finally(() => { if (timer !== undefined) clearTimeout(timer) })
  })
}
